.subsection {
  &__wrapper {
    white-space: pre-line;
  }
  &__title {
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 0;
  }
}
